import client from '../api/inventory-request';

function asRows(value) {
  if (Array.isArray(value)) return value;
  if (typeof value === 'number' && value > 0) {
    return Array.from({ length: value }, () => ({}));
  }
  return [];
}

function vendorIdsFromRfq(rfq = {}) {
  const payload = rfq.rfq_payload && typeof rfq.rfq_payload === 'object' ? rfq.rfq_payload : {};
  return (payload.invited_vendor_ids || rfq.invited_vendor_ids || rfq.vendor_ids || [])
    .filter(Boolean);
}

function failLabel(row) {
  if (!row || typeof row === 'string') return String(row || 'email send failed');
  const id = row.vendor_id || row.id || '';
  const reason = row.reason || 'email send failed';
  return id ? `${id}: ${reason}` : reason;
}

export function summarizeRfqInviteNotify(notify) {
  const sentRows = asRows(notify?.sent);
  const failedRows = asRows(notify?.failed);
  const sent = typeof notify?.sent === 'number' ? notify.sent : sentRows.length;
  const failed = typeof notify?.failed === 'number' ? notify.failed : failedRows.length;
  const failText = failedRows.map(failLabel).filter(Boolean).join('; ');
  if (sent && failed) {
    return `Invited ${sent} vendor(s). Failed: ${failText || failed}`;
  }
  if (sent) {
    return `Invited ${sent} vendor(s).`;
  }
  if (failed) {
    return failText || 'Could not email invited vendors — share the vendor link manually.';
  }
  return 'No invitation emails were sent.';
}

/**
 * Staff inventory invite mailer. Body is only vendor_ids — server writes the letter.
 * Publish must not fail if this call fails.
 */
export async function notifyInvitedVendorsOnPublish(rfqId, {
  rfq: rfqHint = {},
  vendorIds: vendorIdsHint,
} = {}) {
  const empty = { sent: [], failed: [], url: '' };
  if (!rfqId) return empty;

  let vendorIds = (vendorIdsHint && vendorIdsHint.length)
    ? vendorIdsHint.filter(Boolean)
    : vendorIdsFromRfq(rfqHint);

  if (!vendorIds.length) {
    try {
      const live = await client.get(`/inventory/rfqs/${rfqId}/`);
      vendorIds = vendorIdsFromRfq({ ...rfqHint, ...(live || {}) });
    } catch {
      return empty;
    }
  }
  if (!vendorIds.length) return empty;

  const data = await client.post(`/inventory/rfqs/${rfqId}/vendor-email-invite/`, {
    vendor_ids: vendorIds,
  });
  return {
    sent: Array.isArray(data?.sent) ? data.sent : [],
    failed: Array.isArray(data?.failed) ? data.failed : [],
    url: data?.url || '',
  };
}
